import React from 'react';
import { Home, Clock, Award, Sparkles, ShieldCheck, IndianRupee } from 'lucide-react';

export const WhyChooseUs: React.FC = () => {
  const trustPoints = [
    {
      icon: Home,
      title: 'At Your Home Comfort',
      desc: 'Relax, refresh, and feel pampered in your own private room without travel hassle.'
    },
    {
      icon: Clock,
      title: 'Save Time & Travel',
      desc: 'No traffic or salon queues. Quick booking with on-time arrival at your preferred slot.'
    },
    {
      icon: Award,
      title: 'Professional Expert Service',
      desc: 'Experienced, courteous and thoroughly verified female beauty specialists.'
    },
    {
      icon: Sparkles,
      title: 'Best Quality Products',
      desc: 'Premium branded cosmetics, waxes, and packs with 100% honesty and transparency.'
    },
    {
      icon: ShieldCheck,
      title: 'Hygienic & Safe',
      desc: 'Single-use disposables, sanitized tools, and sealed kits for your complete safety.'
    },
    {
      icon: IndianRupee,
      title: 'At Budget Pricing',
      desc: 'Transparent salon menu prices starting at ₹30, free doorstep visit (min ₹300), and zero hidden charges.'
    }
  ];

  return (
    <section id="why-us" className="trust-section">
      <div className="section-container">
        <div className="section-title-wrap">
          <span className="section-eyebrow">The Blishka Promise</span>
          <h2 className="section-main-heading">Why Choose Blishka?</h2>
          <span className="section-script-subtitle">Because you deserve to feel good ♡</span>
        </div>

        {/* ── Mobile Compact Catchy Badges Grid (Active on <= 768px) ── */}
        <div className="mobile-trust-grid">
          {trustPoints.map((point, idx) => {
            const IconComp = point.icon;
            return (
              <div key={idx} className="mobile-trust-chip">
                <div className="mobile-trust-icon">
                  <IconComp size={16} />
                </div>
                <span className="mobile-trust-label">{point.title}</span>
              </div>
            );
          })}
        </div>

        {/* ── Desktop Detailed Cards Grid (Active on > 768px) ── */}
        <div className="trust-grid desktop-trust-grid">
          {trustPoints.map((point, idx) => {
            const IconComp = point.icon;
            return (
              <div key={idx} className="trust-card">
                <div className="trust-icon-circle">
                  <IconComp size={24} />
                </div>
                <div>
                  <h3 className="trust-title">{point.title}</h3>
                  <p className="trust-desc">{point.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
